import React, { useEffect, useState } from "react";
import useGlobal from "../../store";
import { spaceById, getSpaceVariables } from "../../services/MetadataService";

import ModuleLink from "../../components/ModuleLink";

const SpaceConfiguration = (props) => {
    const [space, setSpace] = useState()
    const [variables, setVariables] = useState()
    const[location, setLocation] = useState('Advanced Settings')
    let [currentState, currentActions] = useGlobal();

    useEffect(() => {
        if (!space) {
            let spaceId = props && props.spaceId
            spaceById(spaceId).then(response => {
                setSpace(response)
            });
        }

        if (!variables) {
            let spaceId = props && props.spaceId
            getSpaceVariables(spaceId).then(response => {
                setVariables(response)
            });
        }
    }, [])

    useEffect(() => {
        if (space) {            
            currentActions.setSpace(space)
        }
    },[space]) 

    useEffect(() => {
        if (currentState.currentModule !==  location) {
            currentActions.setCurrentModule(location)
        }
    },[location])

    return <div className="layer3">
            <div className="location">
                <ModuleLink type="variables" name="Variables" elements={variables} destination={space ? "/variables/space/" + props.spaceId : null} />
            </div>
        </div>

}

export default SpaceConfiguration;